export default "__VITE_ASSET__83fe6714__"